import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Card = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 3.99999H3C2.44771 3.99999 2 4.44771 2 4.99999V11C2 11.5523 2.44771 12 3 12H13C13.5523 12 14 11.5523 14 11V4.99999C14 4.44771 13.5523 3.99999 13 3.99999ZM15 4.99999C15 3.89542 14.1046 2.99999 13 2.99999H3C1.89543 2.99999 1 3.89542 1 4.99999V11C1 12.1046 1.89543 13 3 13H13C14.1046 13 15 12.1046 15 11V4.99999ZM7 7.99999C6.72386 7.99999 6.5 8.22385 6.5 8.49999C6.5 8.77613 6.72386 8.99999 7 8.99999H12C12.2761 8.99999 12.5 8.77613 12.5 8.49999C12.5 8.22385 12.2761 7.99999 12 7.99999H7ZM6.5 10.5C6.5 10.2238 6.72386 9.99999 7 9.99999L10 9.99999C10.2761 9.99999 10.5 10.2238 10.5 10.5C10.5 10.7761 10.2761 11 10 11L7 11C6.72386 11 6.5 10.7761 6.5 10.5ZM5 9.49999C5 9.77613 4.77614 9.99999 4.5 9.99999C4.22386 9.99999 4 9.77613 4 9.49999C4 9.22385 4.22386 8.99999 4.5 8.99999C4.77614 8.99999 5 9.22385 5 9.49999ZM6 9.49999C6 10.3284 5.32843 11 4.5 11C3.67157 11 3 10.3284 3 9.49999C3 8.67156 3.67157 7.99999 4.5 7.99999C5.32843 7.99999 6 8.67156 6 9.49999Z"
        fill={color}
      />
    </svg>
  )
})

export default Card
